import { useBranding } from "../../branding";
import { Card, cx } from "../../components";
import { useSectionReveal } from "../../motion";
import styles from "./Vitrine.module.css";

/** Les trois espaces ; le troisième porte le nom de l'ESN de l'instance. */
const espaces = (esn: string) => [
  {
    titre: "Entreprise cliente",
    texte:
      "Achats, projets, validation des feuilles de temps, dashboard avec projection de consommation, historique complet du grand livre. Ses membres, sa marque.",
  },
  {
    titre: "Consultant",
    texte:
      "Ses projets et ses feuilles de temps, mois par mois, en demi-journées. Rien du portefeuille : ni tarif, ni montant.",
  },
  {
    titre: esn,
    texte:
      "L'ESN qui opère la plateforme : ses entreprises clientes et leurs portefeuilles, la grille tarifaire, ses consultants, toutes les feuilles à valider et les demandes d'inscription.",
  },
];

/** Qui voit quoi : trois espaces, un seul grand livre. */
export function VitrineEspaces() {
  const section = useSectionReveal<HTMLElement>();
  const { esn_name } = useBranding();
  const liste = espaces(esn_name);

  return (
    <section ref={section} id="espaces" className={cx(styles.sombre, styles.section, styles.sectionSombre, styles.ecran)} aria-labelledby="espaces-titre">
      <div className={styles.sectionEntete} data-anim="reveal">
        <p className={styles.surtitre}>Les espaces</p>
        <h2 id="espaces-titre" className={styles.sectionTitre}>
          Trois espaces, un seul grand livre.
        </h2>
        <p className={styles.sectionChapo}>
          Chacun ne voit que ce qui le regarde. Les écritures, elles, sont les mêmes pour tout le monde.
        </p>
      </div>
      <ul className={styles.cartes}>
        {liste.map((e) => (
          <Card key={e.titre} as="li" data-anim="reveal" className={styles.carteEspace}>
            <h3 className={styles.carteTitre}>{e.titre}</h3>
            <p className={styles.carteTexte}>{e.texte}</p>
          </Card>
        ))}
      </ul>
    </section>
  );
}
